<template>
  <a-card title="任务管理">
    <p>任务集合，设置之后，列表会展示该集合下的任务</p>
    <a-textarea  v-model:value="preset_ids" :rows="2" placeholder="请输入任务集合 ID，多个 ID 用逗号隔开" />
    <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
      <a-form-item>
        <a-input placeholder="任务 ID" v-model:value="formSearch.task_id" />
      </a-form-item>
      <a-form-item>
        <a-input placeholder="用户 ID" v-model:value="formSearch.user_id" />
      </a-form-item>
      <!-- <a-form-item  label="任务状态"  name="status">
        <a-select
          :allowClear="true"
          style="width: 100px;"
          v-model:value="formSearch.status"
          :options="statusOptions"
        />
      </a-form-item> -->
      <a-form-item>
        <a-input placeholder="Queue Name" v-model:value="formSearch.queue_name" />
      </a-form-item>
      <a-form-item  label="工具类型"  name="tool_id">
        <a-select
          :allowClear="true"
          show-search
          option-filter-prop="label"
          style="width: 100px;"
          v-model:value="formSearch.tool_id"
          :options="ToolIDOptions"
        />
      </a-form-item>
      <a-form-item  label="任务类型"  name="style_id">
        <a-select
            :allowClear="true"
            show-search
            option-filter-prop="label"
            style="width: 230px;"
          v-model:value="formSearch.style_id"
          :options="TaskStyleGroupOptionsAll"
        />
      </a-form-item>
      <a-form-item   label="任务子类型"  name="sub_type">
        <a-select
          :allowClear="true"
        style="width:140px;"
          v-model:value="formSearch.sub_type"
          :options="SubTypeOptions"
          placeholder="SubType"
        />
      </a-form-item>
      <a-form-item  >
        <a-input placeholder="模板 ID" v-model:value="formSearch.template_id" />
      </a-form-item>
      <a-form-item>
          <a-checkbox v-model:checked="showFirst">仅展示第一条</a-checkbox>
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          @click="handleTableChange()"
          shape="circle"
        >
        <template #icon><SearchOutlined /></template>
        </a-button>
      </a-form-item>
    </a-form>
  
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table 
    class="ant-table-striped"
    show-quick-jumper
    :row-key="record => record.id"
    :data-source="dataSource" 
    :columns="columns" 
    :pagination="pagination"
    :loading="loading"
    @change="handleTableChange"
    :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
    >
      <template #id="{ record }">
      {{ record.id }}
        <a-tag v-if="record.is_first" color="red">First</a-tag>
      </template>
      <template #nickname="{ record }">
        <div style="width: 140px;">Task ID: <a-tag>{{ record.id }}</a-tag></div>
        <div>UID: <a-tag>{{ record.user_id }}</a-tag></div>
        <div>昵称: {{ record.nickname ? record.nickname : '-' }}</div>
        <a-tag v-if="record.is_vip" color="red">VIP</a-tag>
      </template>
      <template #base_img="{ record }">
       <div class="img-thumbnail" style="width: 300px;">
          <a-image-preview-group :preview="{ visible: record.visible, onVisibleChange: vis => ( record.visible = vis) }" >
          <a-space>
             <a-image
                placehoder=false
                :preview='{src: rawImage(record.base_image_file)}'
                :src="thumbnail(record.base_image_file)"
                :alt="'原图'"
            />
          <a-space direction="vertical">
            <a-image  style="width:50px"
              v-for="itm of record.works" :key="itm.id"
                placehoder=false
                :preview='{ src: rawImage(itm.works_url), current: record.review_current }'
                :src="thumbnail(itm.works_url)"
                @click="record.review_current = 2"
              />
            <!-- refer image -->
            <a-image  style="width:50px"
              v-if="record['refer_image_url']"
              placehoder=false
              :preview="{src: rawImage(record['refer_image_url'])}"
              :src="thumbnail(record['refer_image_url'])"
            />
            <a-image  style="width:50px"
              v-if="record['extra_params'] && record['extra_params']['image'] && record['extra_params']['image']['refer_url']"
              placehoder=false
              :preview="{src: rawImage(record['extra_params']['image']['refer_url'])}"
              :src="thumbnail(record['extra_params']['image']['refer_url'])"
            />
            <a-image  style="width:50px"
              v-if="(record['sub_type'] == 'replace_hair' || record['sub_type'] == 'replace_hair_omni') && record['extra_params'] && record['extra_params']['value']"
              placehoder=false
              :preview="{src: rawImage(`static/options/hair/${record['extra_params']['value']}.jpg`)}"
              :src="thumbnail(`static/options/hair/${record['extra_params']['value']}.jpg`)"
            />
            <!-- refer image end -->
            <a-image  style="width:50px"
              v-if="record['mask_file']"
              placehoder=false
              :preview="{src: rawImage(record['mask_file'])}"
              :src="thumbnail(record['mask_file'])"
            />
            <a-image
              style="display: none;"
                placehoder=false
                :preview='{src: rawImage(record.base_image_file)}'
                :src="thumbnail(record.base_image_file)"
                :alt="'原图'"
            />
            </a-space>
         </a-space>
         </a-image-preview-group>
       </div>
      </template>
      <template #works="{ record }">
        <div class="img-thumbnail">
          <template v-if="record.style_id == '90'" >
              <template  v-for="itm of record.works" :key="itm.id"  >
                <video 
                  v-if="itm.works_url.indexOf('.mp4') > 0"
                  :poster="thumbnail(record.base_image_file)"
                  preload="none"
                  :src="rawImage(itm.works_url)"
                  controls
                  style="max-width: 200px; max-height: 356px;"
                />
            </template>
          </template>
          <a-image-preview-group >
            <div v-for="itm of record.works" :key="itm.id"  style="display: block; "  >
             <a-image 
              placehoder=false
              :preview='{src: rawImage(itm.works_url)}'
              :src="thumbnail(itm.works_url)"
            />
            <a-tag v-if="itm.gen_source" color="#2db7f5" >{{ itm.gen_source }}</a-tag>
            <a-tag v-if="itm.is_reviewed" color="green">已查看</a-tag>
            <a-tag v-if="itm.continual_task_id > 0" color="red">继续编辑(<a style="color:blue;" :href="'/home/creation/works?task_id='+itm.continual_task_id">{{ itm.continual_task_id }}</a>)</a-tag>
            <a-tag> (下载: {{ itm.download_total }}, live: {{ itm.live_download_total }})</a-tag>
            <p v-if="itm.extend_param">{{ itm.extend_param.remark }}</p>
          </div>
          </a-image-preview-group>
        </div>
      </template>
      <template #prompt="{ record }">
       <div class="prompt-container"  v-on:click="showBigModel(record)">
        <div>{{ record.prompts }}</div>
        <hr v-if="record.prompts"/>
       <div>{{ record.trans_prompts }}</div>
       </div>
      </template>
      <template #review_mark="{ record }">
        <a-space direction="vertical">
          <div>
           MaskTy: 
           <a-tag v-if="record.options == 0 " color="blue">手涂</a-tag>
          <a-tag v-if="record.options == 1 " color="green">自动</a-tag>
        </div>
        <div>
           Quality:
            <a-tag v-if="record.works && record.works.length > 0 && record.works[0].download_total > 0 " color="red">HIGH</a-tag>
             <a-tag v-else >LOW</a-tag>
        </div>
        </a-space>
      </template>
      <template #style_title="{ record }">
        <div v-if="record.status == 2 || record.status == 3" >
           <TestcaseAddon :item="{...record, is_task: true}"></TestcaseAddon>
        </div>
        <div>
          <span style="font-weight: bold;">{{ TaskStatus[record.status] }}</span> 
          <span v-if="record.reason">({{ record.reason }})</span>
        </div>
        <div v-if="record.cost" >耗时: {{  record.cost }}s</div>
        create_kind: {{ record.create_kind }} <br/>
        tool_id: {{ record.tool_id }} <br/>
        style_id:  <a-tag>{{ record.style_id }} ({{ StyleNames[record.style_id] }})</a-tag> <br/>
        sub_type: {{ record.sub_type }} <br/>
        mask_type: <a-tag v-if="record.options == 0 " color="blue">手涂</a-tag>
        <a-tag v-if="record.options == 1 " color="green">自动</a-tag>
        <a-tag v-if="record.options == 2 " >没有</a-tag>
        <br/>
        template_id: {{ record.template_id }} <br/>
        app_version: <a-tag color="blue">{{ record.app_version }}</a-tag> <br/>
  
        is_deleted: <a-tag v-if="record.is_delete" color="red">已删除</a-tag><span v-else >0</span><br/>
        queue: <a-tag>{{ record.queue_name }}</a-tag> <br/>
        pre_task_id: <span v-if="record.pre_task_id">
           <a :href="'/home/creation/works?task_id='+record.pre_task_id">{{ record.pre_task_id }}</a>
          </span> 
          <span v-else>0</span><br/>
        开始时间： {{ record.task_start_at }} <br/>
        创建时间： {{ record.created_at }} <br/>
        修改时间： {{ record.updated_at }} <br/>
      </template>
      <template #expandedRowRender="{record}">
        <div style="background: #EFEFEF;padding:10px;">
          <div v-for="(value, key) of record" :key="key">
            <a-row >
              <a-col :span="3" >{{ key }}:</a-col>
              <a-col :span="21" style="margin-top:4px;" >
                <div v-if="key == 'extra_params' || key == 'works'">
                  <pre>{{ value }}</pre>
                </div>
                <div v-else-if="typeof value == 'number' ">
                  <a-tag>{{ value }}</a-tag>
                </div>
                 <div v-else-if="value === '' ">
                   <a-tag>&lt;empty&gt;</a-tag>
                </div>
                <div v-else>{{ value }}</div>
              </a-col>
            </a-row>
          </div>
        </div>
      </template>
      <template #task_start_at="{ record }">
        开始时间： {{ record.task_start_at }} <br/>
        创建时间： {{ record.created_at }}
      </template>
    </a-table>
    
  </a-card>

  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  h,onMounted} from 'vue'
import { Modal, message } from 'ant-design-vue';

import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import store from '@/store'
import {useRoute} from 'vue-router'
import TestcaseAddon from '@/components/TestcaseAddon.vue'

import { TaskStyleGroupOptionsAll, SubTypeOptions ,StyleNames, ToolIDOptions} from '@/utils/macro'
import {thumbnail , rawImage} from '@/utils/image'

// 0排队中 1创作中 2创作完成 3创作失败
const TaskStatus = {
  0: "🚗 排队中..",
  1: "🚀 创作中.. ",
  2: "✅ 创作完成 ",
  3: "❌ 创作失败 ",
}
export default defineComponent({
  components: {
    SearchOutlined,TestcaseAddon
  },
  data(){
    return {
      loading: false,
      dataSource: [],
      pageNo: 0,
      StyleNames,
      ToolIDOptions,
      preset_ids:"",
      TaskStyleGroupOptionsAll,
      SubTypeOptions:  SubTypeOptions,
      showFirst: false,
      statusOptions: [{
          label: "所有", value: '',
        },
        {
          label: "排队中", value: 0
        }, {
          label: "执行中", value: 1
        }, {
          label: "执行成功", value: 2
        }, {
          label: "执行失败", value: 3
        }, {
          label: "执行退出", value: 4
        }
      ],
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-quick-jumper': true,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '性能问题，总条数不再展示',

       formSearch: {
        template_id: '',
        tool_id: '',
        style_id: '',
        sub_type: '',
        status: 2,
        user_id: '',
        task_id: '',
        queue_name: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    const route = useRoute()
    if (route.query['task_id']) {
      this.formSearch.task_id = route.query['task_id']
    }
    if (route.query['user_id']) {
      this.formSearch.user_id = route.query['user_id']
    }
    if (route.query['style_id']) {
      this.formSearch.style_id = route.query['style_id']
    }
    if (route.query['tool_id']) {
      this.formSearch.tool_id = route.query['styletool_id_id']
    }
    if (route.query['queue_name']) {
      this.formSearch.queue_name = route.query['queue_name']
    }

    this.handleTableChange()
  },
  computed:{
    user_id : () => {
      if (store) {
        return store.state.user.user_id
      }
      
    }, 
    nickname : () => {
      if (store) {
        return `${store.state.user.nickname}-${store.state.user.user_id}`
      }
      
    },
  },
  methods: {
    showBigModel(record){
      Modal.info({
        title: 'Prompts',
        maskClosable: true,
        content: () => h('div', {}, [
          h('div', {}, `Prompt: ${record.prompts}`), 
          h('hr'),
          h('div', {}, `翻译: ${record.trans_prompts}`)
        ]),
        okText: '复制 Prompt',
        onOk() {
            // 将 record.prompts 复制到剪切板
            navigator.clipboard.writeText(record.prompts)
              .then(() => {
                message.success('复制成功');
              })
              .catch(() => {
                message.error('复制失败');
              });
          },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onCancel() {},
      })
      
    },
    thumbnail,
    rawImage,
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      this.preset_ids = this.preset_ids.replaceAll('"', '')
      this.preset_ids = this.preset_ids.replaceAll("\n", ',')
      let limit = pagi.pageSize
      let orderBy = "id desc"
      if (this.showFirst) {
        limit = 1
        orderBy = "id asc"
      }
      if (this.formSearch.is_oversea) {
        this.formSearch.region_code = 'OVERSEA'
      }
      let ids = ""
      let offset =  (pagi.current - 1) * pagi.pageSize
      if (this.preset_ids != "") {
        let pageIDs = this.preset_ids.split(",")
        // 从 pageIDs 翻页
        if (pagi.current >= 1) {
          pageIDs = pageIDs.slice((pagi.current - 1) * pagi.pageSize, pagi.current * pagi.pageSize)
        }
        ids = pageIDs.join(",")
        offset = 0
        this.formSearch.ids = ids
      }
      const rsp = await request.get('/api/creation/works', {
        offset: offset,
        limit: limit,
        order_by: orderBy,
        ...this.formSearch,
        // after_cursor: afterCursor,
        // before_cursor: beforeCursor,
      })
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      for(let i in this.dataSource) {
        let item = this.dataSource[i]
        if (item.extra_params != "") {
          item.extra_params = JSON.parse(item.extra_params)
          if(item.extra_params["userdefined"]) {
            item.refer_image_url = item.extra_params["userdefined"]
            item.refer_image_url = item.refer_image_url.replace("http://statica.xuantu.pro/", "")

          }
          if(item.extra_params["croped_face"]) {
            item.mask_file = item.extra_params["croped_face"]
            item.mask_file = item.mask_file.replace("http://statica.xuantu.pro/", "")
          }
          item.created_at = new Date(item.created_at).toLocaleString()
          item.updated_at = new Date(item.updated_at).toLocaleString()
        } 
        if (item['refer_image_key']) {
          item['refer_image_url'] = item['refer_image_key']
        }
        item.mask_image_key = item.mask_file
        if (item.works && item.works.length > 0) {
          item.work_image_key = item.works[0]["works_url"]
          for (let j in item.works) {
            if (item.works[j]['extend_param']) {
              item.works[j]['extend_param'] = JSON.parse(item.works[j]['extend_param'])
            }
          }
        }
        
        this.dataSource[i] = item
      }
      if (rsp.data.pagination.total < 23979272) {
        this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      }
      let total = rsp.data.pagination.total
      this.pagination.total = total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
    
  },
  setup(props, context) {
   
    return {
      TaskStatus,
      uploadInput: null,
      columns: [
      // {
      //     title: 'Task ID',
      //     dataIndex: 'id',
      //     key: 'id',
      //     slots: { customRender: 'id' },
      //   },
        {
          title: '标识',
          dataIndex: 'nickname',
          key: 'nickname',
          slots: { customRender: 'nickname' },
        },
        {
          title: '原图',
          dataIndex: 'base_img',
          key: 'base_img',
          slots: { customRender: 'base_img' },
        },
        // {
        //   title: '作品类型',
        //   dataIndex: 'create_kind',
        //   key: 'create_kind',
        // },
        // {
        //   title: '工具类型',
        //   dataIndex: 'create_tool',
        //   key: 'create_tool',
        // },
      
        {
          title: '作品',
          dataIndex: 'works',
          key: 'works',
          slots: { customRender: 'works' },
        },
         {
          title: 'Prompt',
          dataIndex: 'prompt',
          key: 'prompt',
          slots: { customRender: 'prompt' },
        },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   key: 'status',
        //   slots: { customRender: 'status' },
        // },
         {
          title: '标注',
          dataIndex: 'review_mark',
          key: 'review_mark',
          slots: { customRender: 'review_mark' },
        },
       {
          title: '信息',
          dataIndex: 'style_title',
          key: 'style_title',
          slots: { customRender: 'style_title' },
        },
        // {
        //   title: '耗时',
        //   dataIndex: 'cost',
        //   key: 'cost',
        // },
        // {
        //   title: '任务开始时间',
        //   dataIndex: 'task_start_at',
        //   key: 'task_start_at',
        //   slots: { customRender: 'task_start_at' },
        // },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
.img-thumbnail {
  /* max-height: 355px; */
  width: 200px;
  overflow-y: scroll;
}
.thumbnail-wraps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.prompt-container {
  cursor: pointer;
  max-height: 350px;
  max-width: 100px;
  overflow-y: scroll;
}
.prompt-container:hover {
  color: red;
}
</style>
